export const ACCOUNT_DELETION_EMAIL = 'valerio@fusco.fit';

export function buildAccountDeletionMailto(accountEmail = '') {
  const subject = encodeURIComponent('Richiesta cancellazione account Fusco Fit');
  const body = encodeURIComponent(
    `Buongiorno,\n\nrichiedo la cancellazione del mio account Fusco Fit associato all'indirizzo ${accountEmail || '[inserisci email]'}.\n\nResto in attesa delle indicazioni necessarie.\n\nGrazie.`,
  );
  return `mailto:${ACCOUNT_DELETION_EMAIL}?subject=${subject}&body=${body}`;
}
